<template>
  <div @click="closeLayer">
    <div class="main-container detail-container">
      <div class="rule" v-if="details">
        <div class="main-container-head">
          <ul class="breadcrumb">
            <li @click="routetokPage('/')"><a href="javascript:void(0)">首页</a>></li>
            <li @click="returnBack" v-show="details.City"><a href="javascript:void(0)">{{ details.City }}</a>></li>
            <li>{{ details.HotelName }}</li>
          </ul>
          <div class="back-btn" @click="returnBack">← 返回</div>
        </div>
        <div class="main-left detail">
          <div class="hotel-head" id="floatTop">
            <h3>{{ details.HotelName }}<span>({{ details.HotelEName || '' }})</span> <span>({{ details.ID }})</span>
            </h3>
            <div class="star">
                <i class="iconfont icon-unie641" v-if="details.Star>=0"></i>
                <i class="iconfont icon-unie641" v-if="details.Star>=2"></i>
                <i class="iconfont icon-unie641" v-if="details.Star>=4"></i>
                <i class="iconfont icon-unie641" v-if="details.Star>=6"></i>
                <i class="iconfont icon-unie641" v-if="details.Star>=8"></i>
                <i class="iconfont icon-unie641" v-if="details.Star>=10"></i>
                <i class="iconfont icon-unie641" v-if="details.Star>=12"></i>
                <i class="iconfont icon-unie641" v-if="details.Star>=14"></i>
                <i class="iconfont icon-unie641 half" v-if="'135791113'.indexOf(details.Star)>-1"></i>
            </div>
            <p class="address" v-if="From==1">
              <a href="javascript:void(0)">{{ details.DistrictName }}</a><span v-if="details.DistrictName">| </span>
              {{ details.Address }}
              <!--<span class="score"><span>-->
              <!--{{details.Evaluation}} {{details.CommRate}}</span>/5分</span>-->
            </p>
            <p class="address" v-if="From==0">
              {{ details.AddressEn }}
              <!--<span class="score"><span>-->
              <!--{{details.Evaluation}} {{details.CommRate}}</span>/5分</span>-->
            </p>

          </div>
          <div class="hotel-img-content">
            <div class="img-content-left">
              <div class="big-img">
                <ImgLoader :imgUrl="details.Pics[0].Url|replaceImgSrc(4)" v-if="details.Pics&&details.Pics[0]"/>

                <img src="./../../assets/img/defaultHotel.jpg" v-else>
              </div>
            </div>
            <div class="img-content-right">
              <div class="img-item" v-for="(pic,index) in details.Pics" v-show="index<7&&index!=0"
                   v-if="details.Pics&&details.Pics.length>0">
                <ImgLoader :imgUrl="pic.Url|replaceImgSrc(4)"/>

              </div>
              <div class="img-item" v-if="details.Pics.length<7" v-for="item in (numToArray(7-details.Pics.length))">

                <img src="./../../assets/img/defaultHotel.jpg">

              </div>
            </div>
          </div>
        </div>
        <div class="main-right" id="mapandhsbox">
          <div class="price-box">
            <div class="price-left">
                        <span>
                            <span>
                                {{ details.Evaluation }} {{ details.CommRate }}
                            </span>/5分
                        </span>
            </div>
            <div class="price-right">
              <span class="flag1">{{ Currency }}</span>
              <span class="price">{{ lowestPriceRooms.LowestPrice }}</span>
              <span class="flag2">起</span>
            </div>
          </div>
          <div class="title-one">
            <div :class="textIsOpen?'title-one-in title-one-active':'title-one-in'">
              <div class="right-title-a">酒店卖点</div>
              <div class="right-text" id="ovfHeight" v-if="details.SellingPoint">
                <p v-if="!textIsOpen&&details.SellingPoint">{{ details.SellingPoint.slice(0, 50) + '...' }}</p>
                <p v-else>{{ details.SellingPoint }}</p>
                <div class="more" @click="textIsOpen = !textIsOpen" v-if="details.SellingPoint.slice('').length>=2">

                  {{ textIsOpen ? '收起' : '显示更多' }}
                </div>
              </div>
              <div class="right-text" id="ovfHeight" v-else>
                <p>无</p>
              </div>
            </div>

          </div>
          <!--<div class="icon-list">-->
          <!--<div class="list">-->
          <!--<span  v-for="(fcGroup,key) in details.FacilitesByGroup">-->
          <!--<i :class="'iconfont icon-f-'+ikey" v-for="(eqmt,ikey) in fcGroup"></i>-->
          <!--</span>-->
          <!--</div>-->
          <!--</div> -->
          <div class="map-menu" v-if="mapContent">
            <MapView :mapContent="mapContent" :mapCenter="mapCenter"></MapView>
            <!-- <img src="img/map.png" alt=""> -->
            <div class="map-text" @click="scrollMapTo(3)">
              <p>查看位置</p>
            </div>
          </div>
          <!--<History></History>-->
        </div>
      </div>
    </div>
    <div class="section" id="searchBoxDiv">
      <div class="rule section-main">
        <Search :CheckIn="CheckIn" :isFloat="isFloat" :CheckOut="CheckOut" :keys="details.HotelName"
                :AdultCount="AdultCount" :ChildrenCount="ChildrenCount" :RoomCount="RoomCount"
                :ChildrenAges="ChildrenAges" @selectCity="selectCity" @selectHotel="selectHotel"
                @selectLandmark="selectLandmark" @selectRoomPeopelNum="selectRoomPeopelNum"
                @calendarSelect="calendarSelect" :Country='Country' @selectCountry="selectCountry"
                @submit="changeFilter" @selectRoomCount="selectRoomCount"></Search>

        <div class="hotel-content ">
          <div :class="(isTableFloat)?'hotel-content-menu active':'hotel-content-menu'">
            <ul>
              <li @click="scrollTo(0)" :class="titleItemActive==0?'menu-item active':'menu-item'">房型价格</li>
              <li @click="scrollTo(1)" :class="titleItemActive==1?'menu-item active':'menu-item'">酒店介绍</li>
              <li @click="scrollTo(2)" :class="titleItemActive==2?'menu-item active':'menu-item'">设施政策</li>
              <li @click="scrollTo(3)" :class="titleItemActive==3?'menu-item active':'menu-item'">交通周边</li>
              <li @click="scrollTo(4)" :class="titleItemActive==4?'menu-item active':'menu-item'">住客评价</li>
            </ul>
            <div class="room-filter-box" v-show="isAllDataLoaded">
              <div class="remove" @click="clearAllFilter"
                   v-show="roomShowFilter.roomName||roomShowFilter.minPrice!==''||roomShowFilter.policy||roomShowFilter.breakfast">
                清空
              </div>
              <div class="item">
                <h1>{{roomShowFilter.roomTitle||'房型'}}</h1>
                <div class="list">
                  <h1 :class="roomShowFilter.roomName===''?'active':''" @click="showTheRoom('')">不限</h1>
                  <h1 class="text-hide" :class="room.RoomName===roomShowFilter.roomName?'active':''" v-for="room in constData"
                      v-if="room.Prices" @click="showTheRoom(room)">{{ room.RoomName }}</h1>
                </div>
              </div>
              <div class="item">
                <h1>{{roomShowFilter.priceTitle||'夜间均价'}}</h1>
                <div class="list">
                  <h1 :class="roomShowFilter.minPrice===''?'active':''" @click="showThePrice('')">不限</h1>
                  <h1 :class="roomShowFilter.minPrice===0?'active':''" @click="showThePrice(0,'150')">
                    {{ Currency }}150以下</h1>
                  <h1 :class="roomShowFilter.minPrice=='150'?'active':''" @click="showThePrice('150','300')">
                    {{ Currency }}150-300</h1>
                  <h1 :class="roomShowFilter.minPrice=='300'?'active':''" @click="showThePrice('300','600')">
                    {{ Currency }}300-600</h1>
                  <h1 :class="roomShowFilter.minPrice=='600'?'active':''" @click="showThePrice('600','1000')">
                    {{ Currency }}600-1000</h1>
                  <h1 :class="roomShowFilter.minPrice=='1000'?'active':''" @click="showThePrice('1000','')">
                    {{ Currency }}1000以上</h1>
                </div>
              </div>
              <div class="item">
                <h1>{{roomShowFilter.policyTitle||'取消政策'}}</h1>
                <div class="list">
                  <h1 :class="roomShowFilter.policy===''?'active':''" @click="showThePolicy('')">不限</h1>
                  <h1 :class="roomShowFilter.policy?'active':''" @click="showThePolicy(true)">可取消</h1>
                  <h1 :class="roomShowFilter.policy===false?'active':''" @click="showThePolicy(false)">不可取消</h1>
                </div>
              </div>
              <div class="item">
                <h1>{{roomShowFilter.breakfastTitle||'含早情况'}}</h1>
                <div class="list">
                  <h1 :class="roomShowFilter.breakfast===''?'active':''" @click="showTheBreakfast('')">不限</h1>
                  <h1 :class="'含早'==roomShowFilter.breakfast?'active':''" @click="showTheBreakfast('含早')">含早</h1>
                  <h1 :class="'不含早'==roomShowFilter.breakfast?'active':''" @click="showTheBreakfast('不含早')">不含早</h1>
                </div>
              </div>
            </div>
          </div>
          <div class="positionRelative">
            <vue-progress-bar></vue-progress-bar>
          </div>
          <div>
            <!-- 最低价的房型 -->
            <table class="bargain " v-if="lowestPriceRooms">
              <thead>
              <tr>
                <th width="23%">
                  <div>
                    <p>超值房型</p>
                  </div>
                </th>
                <th class="a-left" width="20%">子产品</th>
                <th class="a-left" width="10%">床型</th>
                <th width="8%">入住人</th>
                <th width="9%">政策</th>
                <th width="9%">剩余库存</th>
                <th width="12%">均价/间/晚</th>
                <th width="9%">操作</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td class="v-top" rowspan="1">
                  <div class="lowestRoomImg"
                       @mouseover="handleUnfoldImg(lowestPrice)"
                       @mouseout="handleUnfoldImg(lowestPrice)">
                    <div class="brief">
                      <img :src="('/'+ lowestPriceRooms.Img)|replaceImgSrc('11')" v-if="lowestPriceRooms.Img"
                           class="swipe-imgs"/>
                      <img src="./../../assets/img/defaultHotel.jpg" v-else class="unknown">
                    </div>
                    <div class="unfold" v-show="lowestPrice.isUnfoldImg" v-if="lowestPriceRooms.Img">
                      <img :src="('/'+ lowestPriceRooms.Img)|replaceImgSrc('11')"
                           class="swipe-imgs"/>
                    </div>
                  </div>
                  <div class="roomFloat">
                    <div class="room-type">{{ lowestPriceRooms.RoomName }}</div>
                    <div class="detail-btn" @click="openDetailShow(lowestPrice,'1')"
                         :id="'layerBtn'+lowestPriceRooms.RoomID+'1'">查看详情
                    </div>
                    <div class="detail-box" v-show="lowestPrice.isDetailShow"
                         :id="'layer'+lowestPriceRooms.RoomID+'1'"
                         :class="{hide:tipRoomID!==lowestPriceRooms.RoomID+'1'||hideLayer}">
                      <div class="close" @click="hideLayer = true">
                        <i class="iconfont icon-guanbi text-close-btn"></i>
                      </div>
                      <div class="roomImgs">
                        <Swipe ref="swiperImgs" v-if="roomImgs.length>0">
                          <SwipeItem v-for="img in roomImgs" :key="img.ImgID">
                            <img :src="('/'+img.Url)|replaceImgSrc('11')" style="width:100%;" class="swipe-imgs"/>
                          </SwipeItem>
                        </Swipe>
                        <img src="./../../assets/img/defaultHotel.jpg" class="unknown" v-else>
                        <!--                            <div class="back back-btn" @click="bannerBtn('prev')">-->
                        <!--                              <i class="iconfont icon-back"></i>-->
                        <!--                            </div>-->
                        <!--                            <div class="back more-btn" @click="bannerBtn('next')">-->
                        <!--                              <i class="iconfont icon-more"></i>-->
                        <!--                            </div>-->
                      </div>
                      <div class="roomTxt" v-show="lowestPrice.isDetailShow">
                        <p v-show="lowestPriceRooms.RoomName" class="roomName">{{ lowestPriceRooms.RoomName }}</p>
                        <p v-show="lowestPriceRooms.Bed">床型：<span>{{ lowestPriceRooms.Bed }}</span></p>
                        <p v-show="lowestPriceRooms.AddBedDesc">加床：<span>{{ lowestPriceRooms.AddBedDesc }}</span></p>
                        <p v-show="lowestPriceRooms.MaxAdultCount">最多入住人：<span>{{ lowestPriceRooms.MaxAdultCount }}人</span></p>
                        <p v-show="lowestPriceRooms.RoomSize">面积：<span>{{ lowestPriceRooms.RoomSize }}平方米</span></p>
                        <p v-show="lowestPriceRooms">窗户：<span>{{ lowestPriceRooms.WindowText }}</span></p>
                        <p v-show="lowestPriceRooms">吸烟：<span>{{ lowestPriceRooms.SmokeText }}</span></p>
                        <p v-show="lowestPriceRooms.NetDesc">网络：<span>{{ lowestPriceRooms.NetDesc}}</span></p>
                        <p v-show="lowestPriceRooms.Floor">楼层：<span>{{ lowestPriceRooms.Floor }}层</span></p>
                      </div>
                    </div>
                  </div>

                </td>
                <td class="a-left roomFloat" style="float:none">
                  <p v-show="lowestPriceRooms.RoomName=='其它'">{{ lowestPrice.RoomName }}</p>
                  {{ lowestPrice.RPName }} 
                  <div class="detail-btn" @click="getSubpro(lowestPrice,1)" v-if="(details.ID==45023||details.ID==920612||details.ID==402864||details.ID==392288||details.ID==27303||details.ID==79188||details.ID==45093||details.ID==16551||details.ID==1277245)&&(lowestPrice.SupRatePlanId&&lowestPrice.SupRatePlanId.length>=20)">查看详情</div>
                  <div class="detail-box" style="padding: 0 10px 20px;" v-show="LowSubpro==lowestPrice.SupRatePlanId&&(details.ID==45023||details.ID==920612||details.ID==402864||details.ID==392288||details.ID==27303||details.ID==79188||details.ID==45093||details.ID==16551||details.ID==1277245)">
                        <div class="roomTxt">
                          <p class="roomName">{{SubproData.RoomTypeName}}</p>
                        </div>
                        <div class="close" @click="LowSubpro = ''">
                          <i class="iconfont icon-guanbi text-close-btn"></i>
                        </div>
                        <div style="float: left;" v-html="SubproData.ProductDescription"></div>
                  </div>
                </td>
                <td>
                  <p>{{ lowestPrice.Bed }}</p>
                </td>
                <td>
                  <div class="line cursorPoint" @mouseover="openMaxCountShow(lowestPrice)"
                       @mouseout="openMaxCountShow(lowestPrice)">
                    <!-- 成人可入住数 -->
                    <div class="room-for-guest">
                      <i class="iconfont icon-yonghu adult" v-if="lowestPrice.MaxPerson>0"
                         v-for="item in numToArray(lowestPrice.MaxPerson)"></i>
                      <i class="iconfont icon-yonghu adult" v-if="!lowestPrice.MaxPerson"
                         v-for="item in numToArray(maxAdultCount)"></i>
                    </div>
                    <!-- 儿童可入住数 -->
                    <div class="room-for-guest">
                      <i class="iconfont icon-yonghu child" v-if="lowestPrice.MaxChildCount>0"
                         v-for="item in numToArray(lowestPrice.MaxChildCount)"></i>
                      <i class="iconfont icon-yonghu child" v-if="!lowestPrice.MaxChildCount"
                         v-for="item in numToArray(maxChildrenCount)"></i>
                    </div>

                    <div class="line-modal" v-show="lowestPrice.isMaxCountShow">
                      最多入住
                      <span>{{ lowestPrice.MaxPerson || AdultCount }}成人</span>
                      <span
                        v-show="lowestPrice.MaxChildCount||ChildrenCount">{{
                          lowestPrice.MaxChildCount || ChildrenCount
                        }}儿童</span>
                    </div>
                  </div>

                  <!-- <i class="iconfont icon-yonghu" v-if="lowestPrice.MaxPerson>0"></i>
                  <i class="iconfont icon-yonghu" v-if="lowestPrice.MaxPerson>1"></i>
                  <i class="iconfont icon-yonghu" v-if="lowestPrice.MaxPerson>2"></i> -->
                </td>
                <td @mouseover="openPolicyShow(lowestPrice)" @mouseout="openPolicyShow(lowestPrice)">
                  <div class="line">
                    <span class="lower-alert" v-show="lowestPrice.CanCancel">可取消</span>
                    <span v-show="!lowestPrice.CanCancel">不可取消</span>

                    <div class="line-modal" v-show="lowestPrice.isPolicyShow">{{ lowestPrice.CancelPolicy }}</div>

                  </div>
                </td>
                <td @mouseover="openRoomShow(lowestPrice,true)" @mouseout="openRoomShow(lowestPrice,false)">
                  <div class="line " v-if="lowestPrice.Stock>=5&&lowestPrice.Tip!=6">
                    房量充足
                  </div>
                  <div class="line lower-alert" v-if="lowestPrice.Stock<5&&lowestPrice.Stock>0&&lowestPrice.Tip!=6">
                    仅剩<label>{{ lowestPrice.Stock }}</label>间
                  </div>

                  <!-- <div class="line"  v-if="lowestPrice.IsAskRoom">等待确认</div> -->
                  <div class="line" v-if="lowestPrice.Tip==6">售罄</div>
                  <div class="line" v-if="lowestPrice.Tip!=6&&lowestPrice.Stock==0">等待确认</div>

                </td>
                <td @mouseover="openRoomShow(lowestPrice,true)" @mouseout="openRoomShow(lowestPrice,false)"
                    class="cursorPoint">
                  <div class="not-cancel">
                    <span>{{ lowestPrice.AvgPrice }}</span>
                    <img src="./../../assets/img/lowestPrice.png" class="lowestPrice-png"/>
                  </div>
                  <div class="confirm" v-if="From==0"><span>总价{{ Currency }}{{ lowestPrice.Price }}</span></div>
                  <div class="confirm" v-if="From==1"><span>总价{{ Currency }}{{ lowestPrice.AdultPrice }}</span></div>
                  <div class="remain floatoff" v-show="lowestPrice.roomShow">
                    <DailyRate :DailyRates="lowestPrice.DailyRates" :price="lowestPrice" :From="From"
                               :RoomCount="RoomCount" :CheckIn="CheckIn" :CheckOut="CheckOut"
                               :IsAskRoom="lowestPrice.IsAskRoom"></DailyRate>
                  </div>
                </td>
                <td @click="book(lowestPriceRooms,lowestPrice)">
                  <div :class="lowestPrice.Tip==1||lowestPrice.Tip==0?'confirm-btn':'confirm-btn disabled'">预订</div>
                  <div class="remain">
                    <label v-if="lowestPrice.Tip==0" class="one">立即确认</label>
                    <label v-if="lowestPrice.Tip==1&&dateToday==CheckIn" class="two">0.5小时内确认</label>
                    <label v-if="lowestPrice.Tip==1&&dateToday!=CheckIn" class="two">1小时内确认</label>

                    <label v-if="lowestPrice.Tip==3">需提前</label>
                    <label v-if="lowestPrice.Tip==4">需连住</label>
                    <label
                      v-if="lowestPrice.Tip==5&&lowestPrice.MiniRoomCount">{{ lowestPrice.MiniRoomCount }}间以上</label>
                    <label v-if="lowestPrice.Tip==6" class="main-table">售罄</label>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
            <div v-show="isTableFloat&&titleItemActive<1" class="float-table-head">
              <div v-show="FloatRoom">
                <div>{{ FloatRoom }}</div>
                <div class="price">{{ Currency }}{{ FloatRoomPrice }}起</div>
              </div>
            </div>
            <div id="tableBox" class="titleItem">
              <!-- 酒店房型-->
              <table class="hotel-table box">
                <thead>
                <tr>
                  <th width="23%">全部房型</th>
                  <th width="20%" class="a-left">子产品</th>
                  <th width="10%" class="a-left">床型</th>
                  <th width="8%">入住人</th>
                  <th width="9%">政策</th>
                  <th width="9%">剩余库存</th>
                  <th width="12%">均价/间/晚</th>
                  <th width="9%">操作</th>
                </tr>
                </thead>
                <tbody v-if="!detailsRooms">
                <tr>
                  <td colspan="7">
                    <div class="textCenter">
                      <Loading :isLogoLoading="isLogoLoading"></Loading>
                    </div>
                  </td>
                </tr>
                </tbody>
                <tbody v-for="(room,idx) in detailsRooms" v-if="room.Prices">

                <tr v-for="(price,index) in room.Prices" v-show="(index<5||room.showAllRooms)">
                  <td class="v-top roomRef" :data-roomname="room.RoomName" :data-price="price.AvgPrice"
                      :rowspan="room.showAllRooms?room.Prices.length:(room.Prices.length>5?6:room.Prices.length)"
                      v-if="index==0">

                    <div class="roomImg"
                         @mouseover="handleUnfoldImg(price)"
                         @mouseout="handleUnfoldImg(price)">
                      <div class="brief">
                        <img :src="('/'+ room.Img)|replaceImgSrc('11')" v-if="room.Img" class="swipe-imgs"/>
                        <img src="./../../assets/img/defaultHotel.jpg" class="unknown" v-else>
                      </div>
                      <div class="unfold" v-show="price.isUnfoldImg" v-if="room.Img">
                        <img :src="('/'+ room.Img)|replaceImgSrc('11')" class="swipe-imgs"/>
                      </div>
                    </div>
                    <div class="roomFloat">
                      <div class="room-type">{{ room.RoomName }}</div>
                      <div class="detail-btn" @click="openDetailShow(price)" :id="'layerBtn'+room.RoomID">查看详情</div>
                      <div class="detail-box" v-show="price.isDetailShow" :id="'layer'+room.RoomID"
                           :class="{hide:tipRoomID!==room.RoomID||hideLayer}">
                        <div class="close" @click="hideLayer = true">
                          <i class="iconfont icon-guanbi text-close-btn"></i>
                        </div>
                        <div class="roomImgs">
                          <Swipe ref="swiperImgs" v-if="roomImgs.length>0">
                            <SwipeItem v-for="img in roomImgs" :key="img.ImgID">
                              <img :src="('/'+img.Url)|replaceImgSrc('11')" style="width:100%;" class="swipe-imgs"/>
                            </SwipeItem>
                          </Swipe>
                          <img src="./../../assets/img/defaultHotel.jpg" class="unknown" v-else>
<!--                          <div class="back back-btn" @click="bannerBtn('prev')">-->
<!--                            <i class="iconfont icon-back"></i>-->
<!--                          </div>-->
<!--                          <div class="back more-btn" @click="bannerBtn('next')">-->
<!--                            <i class="iconfont icon-more"></i>-->
<!--                          </div>-->
                        </div>
                        <div class="roomTxt" v-show="price.isDetailShow">
                          <p v-show="room.RoomName" class="roomName">{{room.RoomName }}</p>
                          <p v-show="room.Bed">床型：<span>{{ room.Bed }}</span></p>
                          <p v-show="room.AddBedDesc">加床：<span>{{ room.AddBedDesc }}</span></p>
                          <p v-show="room.MaxAdultCount">最多入住人：<span>{{ room.MaxAdultCount }}人</span></p>
                          <p v-show="room.RoomSize">面积：<span>{{ room.RoomSize }}平方米</span></p>
                          <p v-show="room">窗户：<span>{{ room.WindowText }}</span></p>
                          <p v-show="room">吸烟：<span>{{ room.SmokeText }}</span></p>
                          <p v-show="room.NetDesc">网络：<span>{{ room.NetDesc}}</span></p>
                          <p v-show="room.Floor">楼层：<span>{{ room.Floor }}层</span></p>
                          <p v-show="!room.RoomSize&&!price.MaxPerson&&!room.Floor&&!room.Bed">请以酒店实际情况为准</p>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="a-left">
                    <p v-show="idx==(detailsRooms.length-1)&&room.RoomNameEn=='others'">{{ price.RoomName }}</p>
                    {{ price.RPName }}
                    <div class="detail-btn" @click="getSubpro(price)" v-if="(details.ID==45023||details.ID==920612||details.ID==402864||details.ID==392288||details.ID==27303||details.ID==79188||details.ID==45093||details.ID==16551||details.ID==1277245)&&(price.SupRatePlanId&&price.SupRatePlanId.length>=20)">查看详情</div>
                    <div class="detail-box" style="padding: 0 10px 20px;" v-show="SubproID==price.SupRatePlanId&&(details.ID==45023||details.ID==920612||details.ID==402864||details.ID==392288||details.ID==27303||details.ID==79188||details.ID==45093||details.ID==16551||details.ID==1277245)">
                        
                        <div class="roomTxt">
                          <p class="roomName">{{SubproData.RoomTypeName}}</p>
                        </div>
                        <div class="close" @click="SubproID = ''">
                          <i class="iconfont icon-guanbi text-close-btn"></i>
                        </div>
                        <div style="float: left;" v-html="SubproData.ProductDescription"></div>
                    </div>
                    <div class="hotel-labels">
                      <div class="label-item" v-if="(price.Attr & 1)==1">连住优惠</div>
                      <div class="label-item" v-if="(price.Attr & 2)==2">早鸟优惠</div>
                      <div class="label-item" v-if="(price.Attr & 4)==4">团房优惠</div>
                    </div>
                  </td>
                  <td>
                    <p>{{ price.Bed }}</p>
                  </td>
                  <td>
                    <div class="line cursorPoint" @mouseover="openMaxCountShow(price)"
                         @mouseout="openMaxCountShow(price)">
                      <!-- 成人可入住数 -->
                      <div class="room-for-guest">
                        <i class="iconfont icon-yonghu adult" v-if="price.MaxPerson>0"
                           v-for="item in numToArray(price.MaxPerson)"></i>
                        <i class="iconfont icon-yonghu adult" v-if="!price.MaxPerson"
                           v-for="item in numToArray(maxAdultCount)"></i>
                      </div>

                      
                      <!-- 儿童可入住数 -->
                      <div class="room-for-guest">
                        <i class="iconfont icon-yonghu child" v-if="price.MaxChildCount>0"
                           v-for="item in numToArray(price.MaxChildCount)"></i>
                        <i class="iconfont icon-yonghu child" v-if="!price.MaxChildCount"
                           v-for="item in numToArray(maxChildrenCount)"></i>
                      </div>

                      <div class="line-modal" v-show="price.isMaxCountShow">
                        最多入住
                        <span>{{ price.MaxPerson || AdultCount }}成人</span>
                        <span
                          v-show="price.MaxChildCount||ChildrenCount">{{
                            price.MaxChildCount || ChildrenCount
                          }}儿童</span>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="line cursorPoint" @mouseover="openPolicyShow(price)" @mouseout="openPolicyShow(price)">
                      <span class="lower-alert" v-show="price.CanCancel">可取消</span>
                      <span v-show="!price.CanCancel">不可取消</span>
                      <div class="line-modal" v-show="price.isPolicyShow">{{ price.CancelPolicy }}</div>
                    </div>
                  </td>
                  <td @mouseover="openRoomShow(price,true)" @mouseout="openRoomShow(price,false)">
                    <div class="line " v-if="price.Stock>=5&&price.Tip!=6">
                      <span>房量充足</span>
                    </div>
                    <div class="line lower-alert" v-if="price.Stock<5&&price.Stock>0&&price.Tip!=6">
                      <span>仅剩<label>{{ price.Stock }}</label>间</span>
                    </div>
                    <div class="line" v-if="price.Tip==6"><span>售罄</span></div>
                    <div class="line" v-if="price.Tip!=6&&price.Stock==0"><span>等待确认</span></div>
                  </td>
                  <td @mouseover="openRoomShow(price,true)" @mouseout="openRoomShow(price,false)" class="cursorPoint">
                    <div class="not-cancel">
                      <span>{{ price.AvgPrice }}</span>
                      <img src="./../../assets/img/lowestPrice.png" class="lowestPrice-png"
                           v-if="index==0&&room.Prices.length>1"/>
                    </div>
                    <div class="confirm" v-if="From==0"><span>总价{{ Currency }}{{ price.Price }}</span></div>
                    <div class="confirm" v-if="From==1"><span>总价{{ Currency }}{{ price.AdultPrice }}</span></div>
                    <div class="remain floatoff" v-show="price.roomShow">
                      <DailyRate :DailyRates="price.DailyRates" :price="price" :From="From" :RoomCount="RoomCount"
                                 :CheckIn="CheckIn" :CheckOut="CheckOut" :IsAskRoom="price.IsAskRoom"
                                 :Tip="price.Tip"></DailyRate>
                    </div>
                  </td>
                  <td @click="book(room,price)">
                    <div :class="price.Tip==1||price.Tip==0?'confirm-btn':'confirm-btn disabled'">预订</div>
                    <div class="remain">
                      <label v-if="price.Tip==0" class="one" style="color: #339999;">立即确认</label>
                      <label v-if="price.Tip==1&&dateToday==CheckIn" class="two">0.5小时内确认</label>
                      <label v-if="price.Tip==1&&dateToday!=CheckIn" class="two">1小时内确认</label>

                      <label v-if="price.Tip==3">需提前</label>
                      <label v-if="price.Tip==4">需连住</label>
                      <label v-if="price.Tip==5&&price.MiniRoomCount">{{ price.MiniRoomCount }}间以上</label>
                      <label v-if="price.Tip==6" class="main-table">售罄</label>
                    </div>
                  </td>
                </tr>
                <tr v-if="room.Prices&&room.Prices.length>5" style="height:33px">
                  <td colspan="8" style="padding:0;" @click="showMoreRooms(room)">
                    <div class="details-show-more-room">

                      {{ room.showAllRooms ? '收起' : ('以上为该房型最便宜的价格，查看更多个' + (room.Prices.length - 5) + '价格') }}
                      <i class="iconfont icon-xiala " v-show="!room.showAllRooms"></i>
                      <i class="iconfont icon-xiala close" v-show="room.showAllRooms"></i>
                    </div>
                  </td>
                </tr>


                </tbody>
                <tbody v-if="detailsRooms&&detailsRooms.length<1&&!lowestPriceRooms">
                <tr>
                  <td class="textCenter" colspan="7" v-if="dataTime==1">正在为您搜索更多低价...</td>
                  <td class="textCenter" colspan="7" v-else>
                    <img src="./../../assets/img/sellout.png"/>
                    <p class="sold-out">
                      暂无符合条件的报价！
                    </p>
                    <p class="sold-out">
                      建议 <span class="sold-out-btn" @click="openDate">更改日期</span> 或 <span class="sold-out-btn"
                                                                                          @click="openSearch">搜索其他酒店</span>
                    </p>
                  </td>
                  <!-- <td class="textCenter" colspan="7" v-show="dataTime==0">暂无数据</td> -->
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!--酒店信息-->
          <div class="hotel-info">
            <!--酒店介绍-->
            <div class="info-title titleItem">酒店介绍 <span>酒店实际信息可能调整，仅供参考，请以实际入住为准。</span></div>
            <div class="info-content ">
              <div class="hotel-label" v-show="details.Attr">
                <div class="label-item" v-if="(details.Attr & 1)==1">连住优惠</div>
                <div class="label-item" v-if="(details.Attr & 2)==2">早鸟优惠</div>
                <div class="label-item" v-if="(details.Attr & 4)==4">团房优惠</div>
              </div>
              <p v-html="details.Intro"></p>
              <p class="mg-top-line">电话:{{ details.Phone }}</p>
              <p class="mg-top-line">地址:{{ details.Address }}</p>
            </div>
            <!--酒店设施-->
            <div class="info-title titleItem">酒店设施 <span>酒店实际信息可能调整，仅供参考，请以实际入住为准。</span></div>
            <div class="info-content ">
              <div class="info-table">
                <div class="info-row" v-for="(fcGroup,key) in details.FacilitesByGroup">
                  <div class="info-head">{{ keyMap[key] || key }}</div>
                  <div class="info-body">
                    <span v-for="eqmt in fcGroup"></i> {{ eqmt }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!--酒店政策-->
            <div class="info-title">酒店政策 <span>酒店实际信息可能调整，仅供参考，请以实际入住为准。</span></div>
            <div class="info-content">
              <div class="info-table">
                <div class="info-row" v-for="(pl,key) in details.Policies">
                  <div class="info-head">{{ key }}</div>
                  <div class="info-body" v-html="pl"></div>
                </div>
              </div>
            </div>
            <!--交通信息-->
            <div class="info-title titleItem">交通信息 <span>酒店实际信息可能调整，仅供参考，请以实际入住为准。</span></div>
            <div class="info-content " v-if="Landmarks">
              <div class="map-box">
                <MapView :mapContent="mapContent" :mapPoints="mapPoints" :mapCenter="mapCenter"></MapView>
              </div>
              <div class="map-menu">
                <ul>
                  <li class="map-menu-item" @click="initMapData(item.list,true,item,Landmarks)"
                      v-for="item in Landmarks">
                    <a href="javascript:void(0)">{{ item.name }} <i class="iconfont icon-xiala"></i></a>
                    <transition name="landmarksIn">
                      <ul class="map-sub-menu" v-show="item.active">
                        <li class="sub-menu-item" v-for="(lm,idx) in item.list">
                          <div class="map-title">{{ lm.Name }}
                            <span>{{ idx + 1 }}</span>
                          </div>
                          <p>{{ lm.Info }}</p>
                        </li>
                      </ul>
                    </transition>
                  </li>
                </ul>
              </div>
            </div>
            <!--周边信息-->
            <div class="info-title ">周边信息 <span>酒店实际信息可能调整，仅供参考，请以实际入住为准。</span></div>
            <div class="info-content" v-if="Landmarks1">
              <div class="map-box">
                <MapView :mapContent="mapContent" :mapPoints="mapPoints1" :mapCenter="mapCenter"></MapView>
              </div>
              <div class="map-menu">
                <ul>
                  <li class="map-menu-item" @click="initMapData(item.list,false,item,Landmarks1)"
                      v-for="item in Landmarks1">
                    <a href="javascript:void(0)">{{ item.name }} <i class="iconfont icon-xiala"></i></a>
                    <transition name="landmarksIn">
                      <ul class="map-sub-menu" v-show="item.active">
                        <li class="sub-menu-item" v-for="(lm,idx) in item.list">
                          <div class="map-title">{{ lm.Name }}
                            <span>{{ idx + 1 }}</span>
                          </div>
                          <p>{{ lm.Info }}</p>
                        </li>
                      </ul>
                    </transition>
                  </li>
                </ul>
              </div>
            </div>
            <div id="stopScroll"></div>
            <!-- 评价-->
            <div class="info-title titleItem">住客评价 <span>酒店实际信息可能调整，仅供参考，请以实际入住为准。</span></div>
            <div class="info-content ">
              <div class="hotel-detaisl-score">
                <CanvasScore :score="details.CommRate"></CanvasScore>
                <!-- <span class="curr-score">{{details.CommRate}}</span> -->
                <span>{{ details.Evaluation }}<br/>总分5分</span>
              </div>
              <div class="score-box">
                <div class="score-item">
                  <span class="score-label">位置</span>
                  <span class="progress">
									<span class="progress-line" :style="'width: '+(details.SurroundRate/5)*100+'%'"></span>
								</span>
                  <span class="score-label">{{ details.SurroundRate }}</span>
                </div>
                <div class="score-item">
                  <span class="score-label">设施</span>
                  <span class="progress">
									<span class="progress-line" :style="'width: '+(details.FacilityRate/5)*100+'%'"></span>
								</span>
                  <span class="score-label">{{ details.FacilityRate }}</span>
                </div>
              </div>
              <div class="score-box">
                <div class="score-item">
                  <span class="score-label">服务</span>
                  <span class="progress">
									<span class="progress-line" :style="'width: '+(details.ServiceRate/5)*100+'%'"></span>
								</span>
                  <span class="score-label">{{ details.ServiceRate }}</span>
                </div>
                <div class="score-item">
                  <span class="score-label">卫生</span>
                  <span class="progress">
									<span class="progress-line" :style="'width: '+(details.CleanRate/5)*100+'%'"></span>
								</span>
                  <span class="score-label">{{ details.CleanRate }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="textCenter" v-if="!details">
          <Loading :isLoading="true"></Loading>
        </div>
        <Modal v-show="modal.show" :config="modal" @close="modal.show=false" @ok="modalOK"></Modal>
      </div>
    </div>

  </div>
</template>
<script>
import ImgLoader from './../../common/cmpnt/imgLoader/imgLoader.vue'//图片异步加载+效果
import Loading from './../../common/cmpnt/Loading/Loading.vue'//缓冲
import DatePicker from './../../common/cmpnt/datePicker/datePicker.vue'//日期
import MapView from './../../common/cmpnt/map/Map.vue'//地图
import History from './../../common/cmpnt/History/History.vue'//历史记录
import Search from './../../common/cmpnt/searchBox/searchBox'//模糊搜索
import CanvasScore from './../../common/cmpnt/CanvasScore/CanvasScore.vue'//评分图圈
import DailyRate from './dailyRate/dailyRate'//价格日历浮窗
import Modal from './../../common/cmpnt/Modal/modal.vue'//跳转提示框
import coordtransform from 'coordtransform';//经纬度转为高德的标准
require('vue-swipe/dist/vue-swipe.css');
const {Swipe, SwipeItem} = require('vue-swipe');
//导入设施设备匹配列表
import eqmtList from './../../common/equitment.js'
import gps from './../../common/cmpnt/map/transform.js';

export default {
  name: 'hotelDetails',
  components: {
    ImgLoader,
    CanvasScore,
    Loading,
    DailyRate,
    Search,
    DatePicker,
    History,
    Modal,
    MapView,
    SwipeItem,
    Swipe,
  },
  data() {
    return {
      textIsOpen: false,
      thisGps: gps.gps,
      lastKey: this.$route.query.lastKey || '',
      Currency: this.dao.get('userInfo').Currency,
      CityName: this.dao.get('hotelDetailsParams').CityName,
      HotelID: this.dao.get('hotelDetailsParams').HotelID,
      From: Number(this.dao.get('hotelDetailsParams').From),
      ProductType: this.dao.get('hotelDetailsParams').ProductType || '4',
      CheckIn: this.dao.get('hotelDetailsParams').CheckIn,
      CheckOut: this.dao.get('hotelDetailsParams').CheckOut,
      RoomCount: this.dao.get('hotelDetailsParams').RoomCount,
      AdultCount: Number(this.dao.get('hotelDetailsParams').AdultCount),
      ChildrenCount: this.dao.get('hotelDetailsParams').ChildrenCount,
      ChildrenAges: this.dao.get('hotelDetailsParams').ChildrenAges,
      MyLat: this.dao.get('hotelDetailsParams').MyLat,
      MyLon: this.dao.get('hotelDetailsParams').MyLon,
      MyCityRegionID: this.dao.get('hotelDetailsParams').MyCityRegionID,
      RegionID: this.dao.get('hotelDetailsParams').RegionID,
      Country: this.dao.get('hotelDetailsParams').Country || {
        "Code2": "CN",
        "Code3": "CHN",
        "Num": "156",
        "Iso": "ISO 3166-2:CN",
        "ENName": "China",
        "CNName": "中国大陆"
      },
      maxAdultCount: '',//最大可入住成人人数
      maxChildrenCount: '',//最大可入住儿童数
      dataTime: 0,//数据请求的第几次
      details: '',
      detailsRooms: '',
      detailsOtherRooms: [],//其它房型
      lowestPrice: '',//最低价
      lowestPriceRooms: '',//最低价房型
      //地图数据
      Landmarks: '',
      Landmarks1: '',
      mapContent: '',
      mapPoints: [],
      mapPoints1: [],
      mapCenter: {},
      mapCenter1: {},
      mapCenter2: {},

      dateToday: this.getDate(0),
      eqmtList: eqmtList,
      Batch: false,//批量查询价格，当Batch===0时，查第一次，当Batch===1时，查第二次
      //热门城市，地标
      selectAllShow: false,
      isFloat: false,
      isTableFloat: false,//价格表头浮动
      isStopMapAndhs: false,//地图悬浮
      mapAndHistoryFixed: false,//地图悬浮
      isAllDataLoaded: false,//数据是否全部加载完成了
      key: '',
      FloatRoom: '',//表头浮动房型名
      FloatRoomPrice: '',//表头浮动房型最低价
      titleItemActive: 0,//内容页滚动标题
      searcDataSave: '',//缓存查询条件，使之跳转正常
      isLogoLoading: true,
      modal: {
        show: false,
        config: {}
      },
      selectAll: {
        show: false,
        key: '',
      },
      calendar: {
        show: false,
        start: this.getDate(0),
        begin: this.getDate(1),
        end: this.getDate(2),
        select: (begin, end) => {
          if (!begin) {
            return;
          }
          this.calendar.begin = begin;
          this.calendar.end = end;
          this.CheckIn = begin;
          this.CheckOut = end;
          this.$nextTick(function () {
            this.calendar.show = false;
            this.changeFilter();
          });
        }
      },
      constData: '',//查询结果缓存，当自定义条件改变得拿来当原始数据
      constRoom: '',//缓存当前选择的房型
      //条件筛选
      roomShowFilter: {
        showa: false,
        showb: false,
        showc: false,
        showd: false,
        roomName: '',
        minPrice: '',
        maxPrice: '',
        policy: '',
        breakfast: '',
        roomTitle:'',
        priceTitle:'',
        policyTitle:'',
        breakfastTitle:'',
      },
      roomImgs: {},//房型图片集
      tipRoomID: '',
      layerPrice: {},
      hideLayer: false,
      SubproID:'',
      LowSubpro:'',
      SubproData:{},
      keyMap: Object.freeze({
        1: '设施服务',
        5: '交通服务',
        6: '前台服务',
        7: '餐饮服务',
        9: '康体设施',
        10: '娱乐设施',
        11: '公共区',
        12: '清洁服务',
        13: '亲子设施',
        14: '商务服务',
        15: '无障碍设施',
        16: '安全与安保',
        18: '运动'
      })
    }
  },

  methods: {
    openDate() {
      var date = document.querySelector('#dateRef');

      date.click();
    },
    openSearch() {
      var key = document.querySelector('#keyRef');

      key.click();
    },
    //条件筛选
    ShowFilter(name){
      this.roomShowFilter.showa=false
      this.roomShowFilter.showb=false
      this.roomShowFilter.showc=false
      this.roomShowFilter.showd=false
      if(name=='a'){
        this.roomShowFilter.showa=true
      }else if(name=='b'){
        this.roomShowFilter.showb=true
      }else if(name=='c'){
        this.roomShowFilter.showc=true
      }else if(name=='d'){
        this.roomShowFilter.showd=true
      }
    },
    //展示某个房型
    showTheRoom(room) {
      this.roomShowFilter.showa=false
      this.roomShowFilter.showb=false
      this.roomShowFilter.showc=false
      this.roomShowFilter.showd=false
      if (!room) {
        this.clearAllFilter();
        this.resetRoomListByFilter();
        return;
      }
      this.clearAllFilter();
      this.roomShowFilter.roomName = room.RoomName;
      this.constRoom = room;
      var arr = [];
      arr.push(room);
      this.detailsRooms = arr;
      this.roomShowFilter.roomTitle = room.RoomName;
      window.scrollTo({
          top: 500,
          behavior: 'smooth'
      });
    },
    //展示价格区间
    showThePrice(min, max) {
      this.roomShowFilter.showa=false
      this.roomShowFilter.showb=false
      this.roomShowFilter.showc=false
      this.roomShowFilter.showd=false
      if(!min){
        this.roomShowFilter.priceTitle = max+'以下'
      }else if(!max) {
        this.roomShowFilter.priceTitle = min+'以上'
      }else{
        this.roomShowFilter.priceTitle = min+'-'+max
      }
      if (min === '') {
        this.roomShowFilter.minPrice = '';
        this.roomShowFilter.maxPrice = '';
        this.roomShowFilter.priceTitle=''
        this.resetRoomListByFilter();
        return;
      };
      this.roomShowFilter.minPrice = min || 0;
      this.roomShowFilter.maxPrice = max || 9999999;
      this.resetRoomListByFilter();
      window.scrollTo({
          top: 500,
          behavior: 'smooth'
      });
    },
    //展示取消政策
    showThePolicy(val) {
      this.roomShowFilter.showa=false
      this.roomShowFilter.showb=false
      this.roomShowFilter.showc=false
      this.roomShowFilter.showd=false
      this.roomShowFilter.policy = val;
      this.resetRoomListByFilter();
      if(val===false){
        this.roomShowFilter.policyTitle = '不可取消'
      }else if(val){
        this.roomShowFilter.policyTitle = '可取消'
      }
      window.scrollTo({
          top: 500,
          behavior: 'smooth'
      });

    },
    //展示是否含早
    showTheBreakfast(val) {
      this.roomShowFilter.showa=false
      this.roomShowFilter.showb=false
      this.roomShowFilter.showc=false
      this.roomShowFilter.showd=false
      this.roomShowFilter.breakfast = val;
      this.roomShowFilter.breakfastTitle = val;
      this.resetRoomListByFilter();
      window.scrollTo({
          top: 500,
          behavior: 'smooth'
      });
    },
    clearAllFilter() {
      this.roomShowFilter.roomName = '';
      this.roomShowFilter.minPrice = '';
      this.roomShowFilter.maxPrice = '';
      this.roomShowFilter.policy = '';
      this.roomShowFilter.breakfast = '';
      this.roomShowFilter.roomTitle = '';
      this.roomShowFilter.priceTitle = '';
      this.roomShowFilter.policyTitle = '';
      this.roomShowFilter.breakfastTitle = '';
      this.constRoom = '';
      this.detailsRooms = this.constData;
    },
    //根据价格条件过滤，显示相应的房态
    isPriceInFilter(price) {

      return (this.roomShowFilter.minPrice === '' && this.roomShowFilter.maxPrice === '') || ((price.AvgPrice >= this.roomShowFilter.minPrice) && (price.AvgPrice <= this.roomShowFilter.maxPrice));
    },
    //根据政策条件过滤，显示相应的房态
    isPolicyInFilter(price) {

      return (this.roomShowFilter.policy === '' || this.roomShowFilter.policy == price.CanCancel)
    },
    //根据含早条件过滤，显示相应的房态
    isBfInFilter(price) {
      // var hasBreakfast = (price.Breakfast != '不含早' ? '含早' : '不含早');
      if(price.Breakfast){
				var hasBreakfast=(price.Breakfast!='不含早'?'含早':'不含早');
			}else{
				var hasBreakfast=(price.RPName.includes('不含早') ? '不含早' : '含早');
			}
      return (this.roomShowFilter.breakfast === '' || this.roomShowFilter.breakfast == hasBreakfast)
    },
    //重新根据条件处理房型数据
    resetRoomListByFilter() {
      var that = this;
      var temp = JSON.stringify(this.constRoom || this.constData);
      var list = [];

      if (this.constRoom) {
        list.push(JSON.parse(temp));
      } else {
        list = JSON.parse(temp)
      }
      var arr = [];
      if (!list || list.length < 1) return;
      for (var i = 0; i < list.length; i++) {
        arr.push(JSON.parse(JSON.stringify(list[i])));
        arr[i]['Prices'] = [];
        if (!(!this.constRoom && !list[i].Prices)) {
          for (var j = 0; j < list[i].Prices.length; j++) {
            list[i].Prices[j]['isInFilter'] = that.isPriceInFilter(list[i].Prices[j]) && that.isPolicyInFilter(list[i].Prices[j]) && that.isBfInFilter(list[i].Prices[j]);

            if (list[i].Prices[j]['isInFilter']) {
              arr[i]['Prices'].push(list[i].Prices[j]);
            }
          }
        }
      }
      this.$nextTick(function () {
        this.detailsRooms = arr;
      })
    },
    //数字转数组
    numToArray(num) {
      var arr = [];
      for (var i = 0; i < num; i++) {
        arr.push(i)

      }
      return arr;

    },
    //选择酒店
    selectRoomPeopelNum(Adult, Children, ages) {
      this.AdultCount = Number(Adult);
      this.ChildrenAges = ages;
      this.ChildrenCount = Number(Children);
      this.changeFilter();

    },
    //打开酒店列表
    routeToHotel() {
      var obj = {
        RegionID: this.RegionID,
        CityName: this.CityName,
        MyCityRegionID: '',
        districtId: '',
        From: this.From,
        Name: '',
        Landmark: '',
        LandmarkCode: this.LandmarkCode,
        LandmarkName: this.LandmarkName,
        Star: '',
        PriceMin: '',
        PriceMax: '',
        CheckIn: this.CheckIn,
        CheckOut: this.CheckOut,
        RoomCount: 1,
        AdultCount: 2,
        ChildrenCount: 0,
        ChildrenAges: [],
        HotelIDs: '',
        Sort: '',
        MyLat: '',
        MyLon: '',
        MyPositionLat: '',
        MyPositionLon: '',
        Country: this.Country,
        key: this.selectAll.key,
      }
      this.dao.set('hotelListSearchParams', obj);
      this.$router.push('/hotelList?lastKey=' + this.lastKey);
    },
    // 展示更多房型
    showMoreRooms(price) {
      this.$nextTick(function () {
        this.$set(price, 'showAllRooms', price.showAllRooms ? false : true);
      });
    },
    //打开详情
    routeToHotelTemp(HotelID) {
      var obj = {
        CityName: this.CityName,
        HotelID: HotelID,
        From: this.From,
        CheckIn: this.CheckIn,
        CheckOut: this.CheckOut,
        RoomCount: 1,
        AdultCount: 2,
        ChildrenCount: [],
        MyLat: '',
        MyLon: '',
        MyCityRegionID: '',
      }
      this.dao.set('hotelTempInfo', obj);
      this.$router.push('/HotelTemp?id=' + HotelID);
    },
    //选择间数
    selectRoomCount(val) {
      this.RoomCount = val;
      this.changeFilter();
    },
    selectCountry(obj) {
      this.Country = obj;
      this.changeFilter();
    },
    //日期选择
    calendarSelect(begin, end) {
      this.CheckIn = begin;
      this.CheckOut = end;
      this.changeFilter();

    },
    //选择城市
    selectCity(city) {
      this.RegionID = city.ID;
      this.From = city.From;
      this.CityName = city.CName || city.SName;
      this.selectAll.key = city.CName || city.SName;
      this.selectAll.show = false;
      this.Name = '';
      this.LandmarkName = '';
      this.LandmarkCode = '';
      //跳到列表
      this.routeToHotel();
    },
    //选择酒店
    selectHotel(hotel) {
      this.From = hotel.From;
      //查询酒店信息
      this.routeToHotelTemp(hotel.HotelID);

    },
    //选择地标
    selectLandmark(landmark) {
      this.RegionID = landmark.CityID;
      this.CityName = landmark.City;
      this.LandmarkCode = landmark.ID;
      this.LandmarkName = landmark.Name;
      this.From = landmark.From;
      this.selectAll.key = landmark.Name;
      this.selectAll.show = false;
      this.Name = '';
      //跳到列表
      this.routeToHotel();
    },
    //返回列表页
    returnBack() {
      this.RegionID = this.details.CityID;
      this.CityName = this.details.City;
      this.routeToHotel();

      // this.$router.push('/hotelList');
    },
    //条件更新后重置参数和结果
    changeFilter($state) {
      this.detailsRooms = '';
      this.lowestPriceRooms = '';
      this.lowestPrice = '';
      this.initData();
    },

    // 单个房间图片集
    getRoomImgs(roomID) {
      var that = this;
      // that.roomImgs = {}
      var params = {
        hotelid: this.HotelID,
        roomid: roomID
        // hotelid: 1108,
        // roomid: 1139108

      }
      that.getRequest({
        url: that.Api.getRoomImgs,
        params: params
      }).then(res => {
        if (res && res.IsSuccess) {
          that.roomImgs = res.Result;
        }
      });
    },

    bannerBtn(type) {
      if (type == 'next') {
        this.$refs.swiperImgs.next()
      } else {
        this.$refs.swiperImgs.prev();
      }
    },

    closeLayer(event) {
      this.SubproID = ''
      this.LowSubpro = ''
      this.roomShowFilter.showa=false
      this.roomShowFilter.showb=false
      this.roomShowFilter.showc=false
      this.roomShowFilter.showd=false
      var layer = document.getElementById('layer' + this.tipRoomID);
      var layerBtn = document.getElementById('layerBtn' + this.tipRoomID);

  
      if (layer) {
        var layerBtnCon = layerBtn.contains(event.target)
        // console.log('layerBtn', layerBtnCon)
        var layerCon = !layer.contains(event.target)
        // console.log('!layer', layerCon)
        if (layerBtnCon) {
          this.hideLayer = false
          return
        } else if (layerCon) {
          this.hideLayer = true
          this.$nextTick(function () {
            this.roomImgs = {}
            this.$set(this.layerPrice, 'isDetailShow', this.layerPrice.isDetailShow = false);
          });
        }
      }
    },

    //房型图片是否放大
    handleUnfoldImg(price) {
      this.$nextTick(function () {
        this.$set(price, 'isUnfoldImg', price.isUnfoldImg ? false : true);
      });
    },

    //查看详情
    openDetailShow(price, str) {
      this.getRoomImgs(price.RoomID)
      this.tipRoomID = price.RoomID + str || price.RoomID
      this.$nextTick(function () {
        this.layerPrice = price;
        this.$set(price, 'isDetailShow', price.isDetailShow = true);
      });
    },
    //查看政策
    openPolicyShow(price) {
      this.$nextTick(function () {
        this.$set(price, 'isPolicyShow', price.isPolicyShow ? false : true);
      });
    },
    //查看最大入住人数
    openMaxCountShow(price) {
      this.$nextTick(function () {
        this.$set(price, 'isMaxCountShow', price.isMaxCountShow ? false : true);
      });
    },
    //查看价格日历
    openRoomShow(price, isShow) {
      this.$nextTick(function () {
        this.$set(price, 'roomShow', isShow);
      });
    },
    //前往下单
    book(room, price) {
      var that = this;
      //缓存酒店token
      var obj = that.details;

      if (price.Tip > 1) {
        that.error({title: '不能预订', content: price.Errors});
        return;
      }
    
      var obj = {
        From: that.From,
        RegionID: that.details.CityID,
        HotelName: obj.HotelName,
        RoomName: room.RoomNameEn == "others" ? price.RoomName : room.RoomName,
        RPName: price.RPName,
        CheckIn: this.searcDataSave.CheckIn,
        CheckOut: this.searcDataSave.CheckOut,
        RoomCount: that.RoomCount,
        AdultCount: that.AdultCount,
        ChildrenCount: this.ChildrenCount,
        ChildrenAges: this.ChildrenAges,
        Star: obj.Star,
        HotelAddress: obj.Address,
        HotelPhone: obj.Phone,
        AdultPrice: that.From === 0 ? price.Price : price.AdultPrice,
        days: that.getDays(that.CheckIn, that.CheckOut),
        Token: price.Token,
        CancelPolicy: price.CancelPolicy,
        Breakfast: price.Breakfast,
        Currency: price.Currency,
        Tip: price.Tip,
        Stock: price.Stock,
        MaxPerson: that.maxAdultCount,
        // Breakfast: price.Breakfast,
        TotalTaxAndFeeAmount:price.TotalTaxAndFeeAmount,
        DailyRates: price.DailyRates,
        Surcharges: price.Surcharges,
        IsAskRoom: price.IsAskRoom,
        NeedIDCard: price.NeedIDCard,
        details: that.details,
        room: room,
        Country: this.Country
      }
      that.dao.set('bookInfo', obj);
      //检查是否可以预订
      that.modal = {
        show: true,
        content: '正在为您核对酒店库存信息，请稍后....',
      }

      that.checkBookAble(price.Token, function (res) {

        that.modal.show = false;
        //价格发生变化，提示变化信息
        if (res.Result.Changed) {
          var price = (res.Result.NewAmount - res.Result.OrgAmount).toFixed(2);
          var str = (res.Result.NewAmount - res.Result.OrgAmount > 0) ? '上涨' : '下降';
          obj.Token = res.Result.Token
          obj.AdultPrice = res.Result.NewAmount
          obj.DailyRates = res.Result.DailyRate
          that.dao.set('bookInfo', obj);
          that.modal = {
            isComfirm: true,
            show: true,
            content: '该房间的价格已变更，价格' + str + '了' + price + '元！是否继续预订？',
          }
        } else {
          that.$router.push('/hotelBook');
        }
      })
    },
    modalOK() {
      this.$router.push('/hotelBook');
    },
    // 检查是否可以预订
    checkBookAble(token, callback) {
      var that = this;
      that.isSubmit = true;
      var flag = that.details.ID=='45023'?true:that.details.ID=='920612'?true:that.details.ID=='402864'?true:that.details.ID=='392288'?true:that.details.ID=='27303'?true:that.details.ID=='79188'?true:that.details.ID=='45093'?true:that.details.ID=='16551'?true:that.details.ID=='1277245'?true:false 
      var param = {
        token: token
      }
      that.postRequest({
        url: that.Api.checkBookable,
        params: param
      }).then(res => {
        that.isSubmit = false;
        //当IsSuccess==true时，表示有库存可以预订
        if (res.IsSuccess) {
          if(flag&&res.Result.RateRource===1){
            var param={
              DateStart:that.searcDataSave.CheckIn,
              DateEnd:that.searcDataSave.CheckOut,
              SRoomId:res.Result.SupRoomId,
              Token:token
            }  
            that.postRequest({
                url:that.Api.getChimelong, 
                params:param
              }).then(Result => {
                  if(Result&&Result.IsSuccess){
                    var data = that.dao.get('bookInfo');
                    data.Chimelong = Result.Result
                    var arr = []
                    // for(let i = 0;i < Result.Result.length;i++){
                    //   for(let j = 0;j < Result.Result[i].SeasonInfos.length;j++){
                    //     Result.Result[i].SeasonInfos[j].Date = Result.Result[i].Date
                    //   }
                    //   arr = arr.concat(Result.Result[i].SeasonInfos)
                    // }
                    
                    ///长隆
                    for(let j = 0;j < Result.Result[0].SeasonInfos.length;j++){
                      Result.Result[0].SeasonInfos[j].Date = Result.Result[0].Date
                    }
                    arr = arr.concat(Result.Result[0].SeasonInfos)



                    data.ChimelongList = arr
                    data.SupRoomId = res.Result.SupRoomId
                    data.RateRource = res.Result.RateRource
                    that.dao.set('bookInfo', data);
                  }
                  callback(res);
				    });
          }else{
            callback(res);
          }
        } else {
          that.initData();
          that.modal.show = false;
          // 此处要做判断，若价格变更，则跟据价格提示用户进行下一步操作
          this.error({title: '提示', content: res.Msg || '不能预订'});

        }
      });
    },
    


    //初始化地标数据
    initLandmarks() {
      var that = this;
      var arr = [];
      var arr1 = [];
      var Landmarks = that.details.Landmarks;
      for (var item in Landmarks) {
        if ('地铁机场火车站'.indexOf(item) > -1) {
          arr.push({
            name: item,
            list: Landmarks[item]
          })
        } else {
          arr1.push({
            name: item,
            list: Landmarks[item]
          })
        }
      }

      if (arr.length > 0) {
        that.Landmarks = arr;//交通信息
        that.initMapData(arr[0].list, true, arr[0], arr);
      }
      if (arr1.length > 0) {
        that.Landmarks1 = arr1;//周围信息
        that.initMapData(arr1[0].list, false, arr1[0], arr1);
      }
            that.$nextTick(() => {
                if(localStorage.getItem('lang')=='t'){
                  that.$zh_tran(localStorage.getItem('lang'))
                }    
            })
    },
    //海外房型名称变小写去空格
    roomNameMange(name) {

      if (!name) return;
      name = name.toLowerCase();
      name = name.replace(/\s*/g, "");
      return name;
    },
    //设置地图参数
    initMapData(landmarks, isFirst, item, list) {
      var that = this;
      list.forEach((item) => {
        item.active = false;

      })
      that.$nextTick(function () {
        that.$set(item, 'active', item.active ? false : true);
      });

      const [hotelLng, hotelLat] = coordtransform.bd09togcj02(+that.details.Lon, +that.details.Lat);

      const center = {
        lat: hotelLat,
        lng: hotelLng,
        name: that.details.HotelName
      };
  
      const arr = [];
      landmarks.forEach(lm => {
        // 核心：BD-09 → GCJ-02
        const [lng, lat] = coordtransform.bd09togcj02(+lm.LON, +lm.LAT);
        arr.push({ lng, lat, name: lm.Name });
      });
      // arr.push(center);
      
      if (isFirst) {
        that.$nextTick(function () {
          that.mapPoints = arr;
        });
        that.mapCenter1 = arr[0];
      } else {
        that.$nextTick(function () {
          that.mapPoints1 = arr;
        });
        that.mapCenter2 = arr[0];
      }

      that.mapCenter = center;
      that.mapContent = that.details.HotelName;

    },
    //加载详情
    initData() {
      var that = this;
      var params = {
        HotelID: this.HotelID,
        ProductType: that.ProductType,
        From: this.From,
        CheckIn: this.CheckIn,
        CheckOut: this.CheckOut,
        RoomCount: this.RoomCount,
        AdultCount: this.AdultCount,
        ChildrenCount: this.ChildrenCount,
        ChildrenAges: this.ChildrenAges,
        MyLat: this.MyLat,
        MyLon: this.MyLon,
        MyCityRegionID: this.MyCityRegionID,
        Lang:0
      }
      that.isLoading = true;
      that.postRequest({
        url: that.Api.hotel,
        params: params
      }).then(res => {
        that.isLoading = false;
        if (res && res.IsSuccess) {
          that.searcDataSave = params;//缓存下查询条件

          that.details = res.Result;
          document.title = '【 ' + (this.details.HotelName || '') + ' 】' + '详细信息,价格,库存,预定---订房易';

          that.setHistory(res.Result);
          //异步处理，防止数据不同步匹配出错
          that.$nextTick(function () {
            that.selectAll.key = that.details.HotelName;
            //处理房型价格

            that.manageRoomPrice(res.Result.Rooms);

            const [hotelLng, hotelLat] = coordtransform.bd09togcj02(+that.details.Lon, +that.details.Lat);

            const center = {
              lat: hotelLat,
              lng: hotelLng,
              name: that.details.HotelName
            };
            that.mapCenter = center;
            that.mapContent = that.details.HotelName;
            that.$nextTick(() => {
                if(localStorage.getItem('lang')=='t'){
                  that.$zh_tran(localStorage.getItem('lang'))
                }    
            })
          });
          if (res.Result.Landmarks && Object.keys(res.Result.Landmarks).length > 0) {
            that.initLandmarks();//整理
          }
        } else {
          that.details = ''
        }
      });
    },
    //匹配房型子产品价格，先从details接口获取所有的房型信息，再分别调price接口得到各个子产品的价格
    //根据房型id&&房型名称追加到房型数据下面。
    //处理房型价格
    manageRoomPrice(list) {
      var that = this;
      if(this.From==1){
        var result0 = this.getPrice(0);
        var result1 = this.getPrice(1);
      }else {
        var result0 = this.getPrice();
        var result1 = ''
      }
      
      var list = list;
      var obj = {
        RoomName: '其它',
        RoomNameEn: 'others',
        LowestPrice: 0,
        Prices: []
      }
      list.push(obj);

      that.isAllDataLoaded = false;

      //滚动监听开始
      // window.addEventListener('scroll', this.handleScroll)
      if (document.addEventListener) {//firefox
        document.addEventListener('DOMMouseScroll', this.handleScroll, false);
      }
      //滚动滑轮触发scrollFunc方法 ie 谷歌
      window.onmousewheel = document.onmousewheel = this.handleScroll;
      // console.log(result0)

      result0.then((res) => {
        var list1 = that.priceMatch(list, res);
        var temp = '';
        that.$nextTick(function () {
          that.dataTime = 1;
          if(!result1){
            that.dataTime = 2;
          }
          that.getLowestPriceRooms(list1);
          temp = JSON.stringify(list1);
          that.detailsRooms = JSON.parse(temp);
          that.constData = JSON.parse(temp)//缓存，作定义处理

          //将可售的排在前面
          that.listSortOfRoomTip(JSON.parse(temp), function (list) {
            that.detailsRooms = list;
            that.getLowestPriceRooms(list);
          });
          // console.log(that.detailsRooms)

        });

        if(result1){
          that.$Progress.start()//进度开始
          result1.then((res1) => {
            that.$nextTick(function () {
              that.dataTime = 2;
            })
            that.$Progress.finish()//进度结束
            that.isAllDataLoaded = true;

            if (!res1 || res1.length < 1) return;

            var list2 = that.priceMatch(JSON.parse(temp), res1);
            that.getLowestPriceRooms(list2);
            var temp2 = JSON.stringify(list2);
            that.$nextTick(function () {
              that.detailsRooms = JSON.parse(temp2);
              that.constData = JSON.parse(temp2)//缓存，作定义处理
              if (that.From == 0) return;
              //将可售的排在前面
              that.listSortOfRoomTip(JSON.parse(temp2), function (list) {
                that.detailsRooms = list;
                that.getLowestPriceRooms(list);
              });

            });
          }).catch((error) => {
            console.log(error)
          })
            that.$nextTick(() => {
                if(localStorage.getItem('lang')=='t'){
                  that.$zh_tran(localStorage.getItem('lang'))
                }    
            })
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    priceMatch(list, room) {

      if (!room || room.length < 1) return list;
      var that = this;
      if (!room || room.length < 1) return;
      for (var i = 0; i < list.length; i++) { //房型
        for (var j = 0; j < room.length; j++) {//价格
          if (list[i].RoomID == room[j].RoomID
            || list[i].RoomName == room[j].RoomName) {
            room[j]['isInclude'] = true;

            //对国内酒店的处理
            if (that.From == 1) {
              if (!list[i]['Prices']) {
                list[i]['Prices'] = that.listSort(room[j].Prices, 'AdultPrice');
                list[i]['LowestPrice'] = room[j].LowestPrice || 0;

              } else {
                list[i]['Prices'] = that.listSort(list[i]['Prices'].concat(room[j].Prices));
                list[i]['LowestPrice'] = room[j].LowestPrice || 0;
              }

              list[i]['Tip'] = list[i]['Prices'][0].Tip;
            } else {
              //对海外酒店的处理
              if (!list[i]['Prices']) {
                list[i]['Prices'] = [];
                list[i]['Prices'].push(room[j]);
                list[i]['Prices'] = that.listSort(list[i]['Prices']);
                list[i]['LowestPrice'] = that.getLowestPrice(list[i]['Prices'], 'AvgPrice');
              } else {
                list[i]['Prices'] = list[i]['Prices'].concat(room[j]);
                list[i]['Prices'] = that.listSort(list[i]['Prices']);
                list[i]['LowestPrice'] = that.getLowestPrice(list[i]['Prices'], 'AvgPrice');
              }
              list[i]['Tip'] = list[i]['Prices'][0].Tip;
            }
          }
        }
      }


      //将未归类的添加到‘其它’中
      //国内
      if (that.From == 1) {
        for (var m = 0; m < room.length; m++) {
          if (!room[m]['isInclude']) {
            // console.log(room[m]['isInclude'])
            // list[list.length-1].Prices.push(room[m]);
            list[list.length - 1].Prices = list[list.length - 1].Prices.concat(room[m].Prices);
          }
        }
        //海外
      } else {
        for (var m = 0; m < room.length; m++) {
          if (!room[m]['isInclude']) {
            list[list.length - 1].Prices.push(room[m]);
          }
        }
      }


      list[list.length - 1]['Prices'] = that.listSort(list[list.length - 1]['Prices'], 'AvgPrice');
      list[list.length - 1]['LowestPrice'] = that.getLowestPrice(list[list.length - 1]['Prices'], 'AvgPrice');
      var temp3 = JSON.stringify(list);
      var list3 = JSON.parse(temp3);
      var last = list3.pop();

      var arr = that.listSort(list3, 'LowestPrice');
      arr.push(last);

      // console.log(arr)
      return arr;
      
    },
    //价格排序,list是排序列表，key是排序关键字
    listSort(list, key) {
      if (!list || list.length < 1) return [];
      list.sort((a, b) => {
        return (a.RoomNameEn != 'others' && b.RoomNameEn != "others") ? ((a[key] || 0) - (b[key] || 0)) : false;
      })

      return list;
    },
    // 将房型可售的排在前面
    listSortOfRoomTip(list, callback) {
      if (!list || list.length == 0) {
        return [];
      }
      var temp = JSON.stringify(list);
      var list = JSON.parse(temp);
      var list2 = [];
      var count = 0;

      for (var i = 0; i < list.length; i++) {
        if (list[i].Prices && list[i].Prices.length > 0) {
          list2.push(this.listSortOfPriceTip(list[i]))
        }
      }

      list2.forEach((item, index) => {
        if (item.Tip > 1) {
          list2.push(item);
          count += 1;
        }
      })
      list2.splice(list2.length - count, list2.length);
      callback(list2);
      // return list2;
    },
    // 将房价可售的排在前面
    listSortOfPriceTip(list) {

      var temp = JSON.stringify(list);
      var list = JSON.parse(temp);

      var count = 0;
      var list2 = [];
      var list3 = [];

      list.Prices.forEach((item, index) => {
        if (item.Tip > 1) {
          list3.push(item);
        } else {
          list2.push(item)
        }
      })
      list.Prices = this.listSort(list2, 'AdultPrice').concat(this.listSort(list3, 'AdultPrice'));

      return list
    },
    //获取最低价，list是排序列表，key是排序关键字
    getLowestPrice(list, key) {
      var price = '';
      if (!list || list.length < 1) {
        return 0;
      } else {
        return price = list[0][key];
      }
    },
    getLowestPriceRooms(list) {
      if (!list || list.length < 1) return;
      var list = JSON.parse(JSON.stringify(list));

      var _list = [];
      for (var i = 0; i < list.length; i++) {
        if (list[i].LowestPrice && list[i].LowestPrice > 0) {
          _list.push(list[i])
        }
      }
      if (!_list || _list.length < 1) return;

      if (_list.length > 1) {

        _list.sort((a, b) => {
          return a.LowestPrice - b.LowestPrice;
        })
      }
      this.lowestPriceRooms = _list[0];
      // console.log(this.lowestPriceRooms)
      this.lowestPrice = _list[0].Prices[0];
    },

    //加载房型价格
    getPrice(batch) {
      var that = this;
      return new Promise((resolve, reject) => {
        var params = {
          HotelID: this.HotelID,
          ProductType: that.ProductType,
          From: this.From,
          CheckIn: this.CheckIn,
          CheckOut: this.CheckOut,
          RoomCount: this.RoomCount,
          AdultCount: this.AdultCount,
          ChildrenCount: this.ChildrenCount,
          ChildrenAges: this.ChildrenAges,
          MyLat: this.MyLat,
          MyLon: this.MyLon,
          MyCityRegionID: this.MyCityRegionID,
          // Batch: batch,
          Lang:0,
          CountryCode: that.Country.Code2
        }
        if(this.From==1){
          params.Batch = batch
        }
        that.isLoading = true;
        that.postRequest({
          url: that.Api.getPrices,
          params: params
        }).then(res => {
          that.isLoading = false;
          if (res && res.IsSuccess) {
            //匹配房型字产品价格
            resolve(res.Result);
            that.maxAdultCount = that.AdultCount;//最大可入住成人人数
            that.maxChildrenCount = that.ChildrenCount;//最大可入住儿童数
          } else {
            reject('');
          }
        });
      }).catch((error) => {
        console.log(error)
      })
    },
    //加载子房型信息
    getSubpro(item,flag) {
      this.SubproID = ''
      this.LowSubpro = ''
      var that = this;
      var params = {
        supRatePlanId:item.SupRatePlanId
      }
      that.modal = {
        show: true,
        content: '正在查询，请稍后...',
      }
      that.getRequest({
          url: that.Api.getChimelongSubpro,
          params: params
        }).then(res => {
          that.modal.show = false;
          if (res && res.IsSuccess&&res.Result) {
            this.SubproData = res.Result
            if(flag){
              this.LowSubpro = item.SupRatePlanId
            }else{
              this.SubproID = item.SupRatePlanId
            }
            that.$nextTick(() => {
              if(localStorage.getItem('lang')=='t'){
                that.$zh_tran(localStorage.getItem('lang'))
              }          
            })
          }else{
            this.error({title: '提示', content: '数据拉取错误！'});
          }
        });
    },
    //设置当前页面滚动对应的标题
    setActiveTitle(top) {
      if (!this.detailsRooms || this.detailsRooms.length < 1) return;
      var list = document.querySelectorAll('.titleItem');
      top -= 340;
      for (var i = 0; i < list.length; i++) {
        if ((list[i].offsetTop < top) && (top < (list[i].offsetTop + list[i].offsetHeight))) {
          this.titleItemActive = i;
          // break;
        }
      }

    },
    //滚动设置当前位置对应的房型名
    setFloatRoomRef(top, tableBoxTop) {
      if (!this.detailsRooms || this.detailsRooms.length < 1) return;
      var list = document.querySelectorAll('.roomRef');
      var parent = document.querySelector('#tableBox');
      top -= 360;
      for (var i = 0; i < list.length; i++) {
        if (((list[i].offsetTop + parent.offsetTop) < top) && (top < (list[i].offsetTop + list[i].offsetHeight + parent.offsetTop))) {
          this.FloatRoom = list[i].dataset.roomname;
          this.FloatRoomPrice = list[i].dataset.price;
          // break;
        }
      }
    },
    //滚动到页面中的指定位置。
    scrollTo(idx) {
      var list = document.querySelectorAll('.titleItem');
      var top = list[idx].offsetTop + 340;
      this.titleItemActive = idx;
      document.body.scrollTop = document.documentElement.scrollTop = top;

    },
    scrollMapTo(idx) {
      var list = document.querySelectorAll('.titleItem');
      var top = list[idx].offsetTop + 240;
      this.titleItemActive = idx;
      document.body.scrollTop = document.documentElement.scrollTop = top;

    },
    //处理屏幕滚动事件
    handleScroll(e) {


      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

      var offsetTop = document.querySelector('#searchBoxDiv') ? document.querySelector('#searchBoxDiv').offsetTop : 0;
      var tableBoxTop = document.querySelector('#tableBox') ? document.querySelector('#tableBox').offsetTop : 0;
      var searchBoxDivTop = document.querySelector('#searchBoxDiv') ? document.querySelector('#searchBoxDiv').offsetTop : 0;
      var tableOffsetHeight = document.querySelector('#tableBox') ? document.querySelector('#tableBox').offsetHeight : 0;

      var floatTop = document.querySelector('#floatTop') ? document.querySelector('#floatTop').offsetTop : 0;

      var stopScrollTop = document.querySelector('#stopScroll') ? document.querySelector('#stopScroll').offsetTop : 0;
      var mapandhsbox = document.querySelector('#mapandhsbox');

      var ovfHeight = document.querySelector('#ovfHeight') ? document.querySelector('#ovfHeight').clientHeight - 280 : '';//或取卖点超出时的大小

      this.mapAndHistoryFixed = scrollTop > (floatTop + 55);

      if (scrollTop > floatTop) {
        if (scrollTop > stopScrollTop - 300) {
          mapandhsbox.style.top = (stopScrollTop - 400) + 'px';
          this.isStopMapAndhs = true;
        } else {
          mapandhsbox.style.top = '0px';
          this.isStopMapAndhs = false;
        }
      }

      this.isFloat = scrollTop > offsetTop;

      this.isTableFloat = (scrollTop > searchBoxDivTop);
      this.setFloatRoomRef(scrollTop, tableBoxTop);
      this.setActiveTitle(scrollTop);

    },
   

  },
  mounted() {
    this.dao.set('bookInfo', '');
    // document.title='【 '+(this.details.HotelName||'')+' 】'+'详细信息,价格,库存,预定---订房易';
    this.initData();
  },

  beforeDestroy() {
    window.removeEventListener('DOMMouseScroll', this.handleScroll);
    window.removeEventListener('onmousewheel', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('onmousewheel', this.handleScroll);
  }

}
</script>



// WEBPACK FOOTER //
// src/components/hotel/Details.vue